const Common = {
  en: {
    UP: "Outbound",
    DOWN: "Inbound",
    arr: "Arriving",
    dep: "Departing",
    min: "min",
    etaAlert:
      "ETA information will be refresh every 10 seconds, reference data only.",
    autoBtnOn: "Auto",
    autoBtnOff: "Auto",
    line: "Line",
    stn: "Station",
    lastUpdate: "Last Update",
    eta: "ETA",
    to: "to ",
    plat: "Platform",
    defaultLine: "Urban Lines",
    saveF: "Save",
    saveT: "Saved",
    routeMap: "Route",
    boundFor: "to",
    ealRAC: "via Racecourse",
    interchange: "Interchange",
    switchTo: "Switch to",
  },
  tc: {
    UP: "上行",
    DOWN: "下行",
    arr: "即將抵達",
    dep: "正在離開",
    min: "分鐘",
    etaAlert: "到站時間資訊每10秒自動更新，資料只供參考。",
    autoBtnOn: "自動",
    autoBtnOff: "自動",
    line: "路線",
    stn: "站",
    lastUpdate: "最後更新",
    eta: "到站時間",
    to: "往",
    plat: "月台",
    defaultLine: "市區線",
    saveF: "儲存",
    saveT: "已儲存",
    routeMap: "路線圖",
    boundFor: "往",
    ealRAC: "經馬場",
    interchange: "轉線",
    switchTo: "轉到",
  },
};

const Error = {
  tc: {
    "NT-205": "暫時沒有預計到達時間數據。",
  },
  en: {
    "NT-205": "ETA Data is not available.",
  },
};

const MtrLines = {
  AEL: {
    tc_name: "機場快線",
    en_name: "Airport Express",
    colorCode: "#1c7670",
    stations: ["HOK", "KOW", "TSY", "AIR", "AWE"],
  },
  TCL: {
    tc_name: "東涌線",
    en_name: "Tung Chung Line",
    colorCode: "#fe7f1d",
    stations: ["HOK", "KOW", "OLY", "NAC", "LAK", "TSY", "SUN", "TUC"],
  },

  TKL: {
    tc_name: "將軍澳線",
    en_name: "Tseung Kwan O Line",
    colorCode: "#6b208b",
    stations: ["NOP", "QUB", "YAT", "TIK", "TKO", "LHP", "HAH", "POA"],
  },
  TML: {
    tc_name: "屯馬線",
    en_name: "Tuen Ma Line",
    colorCode: "#9a3b26",
    stations: [
      "WKS",
      "MOS",
      "HEO",
      "TSH",
      "SHM",
      "CIO",
      "STW",
      "CKT",
      "TAW",
      "HIK",
      "DIH",
      "KAT",
      "SUW",
      "TKW",
      "HOM",
      "HUH",
      "ETS",
      "AUS",
      "NAC",
      "MEF",
      "TWW",
      "KSR",
      "YUL",
      "LOP",
      "TIS",
      "SIH",
      "TUM",
    ],
  },
  EAL: {
    tc_name: "東鐵線",
    en_name: "East Rail Line",
    colorCode: "#5eb6e4",
    stations: [
      "LOW",
      "LMC",
      "SHS",
      "FAN",
      "TWO",
      "TAP",
      "UNI",
      "FOT",
      "RAC",
      "SHT",
      "TAW",
      "KOT",
      "MKK",
      "HUH",
      "EXC",
      "ADM",
    ],
    // Refined path based on actual railway alignment
    trackPath: [
      [22.5283, 114.1134], // LOW
      [22.5180, 114.1200],
      [22.5012, 114.1280], // SHS
      [22.4921, 114.1387], // FAN
      [22.4750, 114.1480],
      [22.4511, 114.1611], // TWO
      [22.4446, 114.1706], // TAP
      [22.4350, 114.1900],
      [22.4134, 114.2102], // UNI
      // --- Racecourse Loop Handling (Simplified as main line for now) ---
      [22.3953, 114.1982], // FOT
      [22.3825, 114.1875], // SHT
      [22.3731, 114.1786], // TAW
      // Lion Rock Tunnel section
      [22.3550, 114.1770],
      [22.3370, 114.1762], // KOT
      [22.3222, 114.1728], // MKK
      [22.3029, 114.1816], // HUH
      // Cross Harbour Section
      [22.2950, 114.1800],
      [22.2818, 114.1754], // EXC
      [22.2788, 114.1646], // ADM
    ]
  },
  SIL: {
    tc_name: "南港島綫",
    en_name: "South Island Line",
    colorCode: "#b5bd00",
    stations: ["ADM", "OCP", "WCH", "LET", "SOH"],
  },
  TWL: {
    tc_name: "荃灣綫",
    en_name: "Tsuen Wan Line",
    colorCode: "#ed1d24",
    stations: [
      "CEN",
      "ADM",
      "TST",
      "JOR",
      "YMT",
      "MOK",
      "PRE",
      "SSP",
      "CSW",
      "LCK",
      "MEF",
      "LAK",
      "KWF",
      "KWH",
      "TWH",
      "TSW",
    ],
  },
  ISL: {
    tc_name: "港島線",
    en_name: "Island Line",
    colorCode: "#0860a8",
    stations: [
      "KET",
      "HKU",
      "SYP",
      "SHW",
      "CEN",
      "ADM",
      "WAC",
      "CAB",
      "TIH",
      "FOH",
      "NOP",
      "QUB",
      "TAK",
      "SWH",
      "SKW",
      "HFC",
      "CHW",
    ],
  },

  KTL: {
    tc_name: "觀塘綫",
    en_name: "Kwun Tong Line",
    colorCode: "#1a9431",
    stations: [
      "WHA",
      "HOM",
      "YMT",
      "MOK",
      "PRE",
      "SKM",
      "KOT",
      "LOF",
      "WTS",
      "DIH",
      "CHH",
      "KOB",
      "NTK",
      "KWT",
      "LAT",
      "YAT",
      "TIK",
    ],
  },
  DRL: {
    tc_name: "迪士尼線",
    en_name: "Disneyland Resort Line",
    colorCode: "#f550a6",
    stations: ["SUN", "DIS"]
  },
  XRL: {
    tc_name: "高速鐵路",
    en_name: "High Speed Rail",
    colorCode: "#9F968C",
  },
  LR: {
    tc_name: "輕鐵",
    en_name: "Light Rail",
    colorCode: "#CD9700",
  },
};

const MtrStations = {
  HOK: {
    tc_name: "香港",
    en_name: "Hong Kong",
    lat: 22.284377,
    lon: 114.1554811,
    interChange: ["TCL", "AEL", "TWL", "ISL"],
    connectedStations: ["CEN"], // 連接中環站
    active: "1",
  },
  KOW: {
    tc_name: "九龍",
    en_name: "Kowloon",
    lat: 22.304306,
    lon: 114.1589001,
    interChange: ["TCL", "AEL", "XRL"],
    connectedStations: ["AUS"], // 連接柯士甸站
    active: "1",
  },
  TSY: {
    tc_name: "青衣",
    en_name: "Tsing Yi",
    lat: 22.358843,
    lon: 114.1045586,
    interChange: ["TCL", "AEL"],
    active: "1",
  },
  AIR: {
    tc_name: "機場",
    en_name: "Airport",
    lat: 22.3525575,
    lon: 114.1393992,
    active: "1",
  },
  AWE: {
    tc_name: "博覽館",
    en_name: "AsiaWorld Expo",
    lat: 22.3208341,
    lon: 113.939264,
    active: "1",
  },
  OLY: {
    tc_name: "奧運",
    en_name: "Olympic",
    lat: 22.3178432,
    lon: 114.1575608,
    active: "1",
  },
  NAC: {
    tc_name: "南昌",
    en_name: "Nam Cheong",
    lat: 22.3267772,
    lon: 114.151105,
    interChange: ["TCL", "TML"],
    active: "1",
  },
  LAK: {
    tc_name: "荔景",
    en_name: "Lai King",
    lat: 22.348561,
    lon: 114.1232946,
    interChange: ["TCL", "TWL"],
    active: "1",
  },
  SUN: {
    tc_name: "欣澳",
    en_name: "Sunny Bay",
    lat: 22.331731,
    lon: 114.0263858,
    interChange: ["TCL", "DRL"],
    active: "1",
  },
  TUC: {
    tc_name: "東涌",
    en_name: "Tung Chung",
    lat: 22.289255,
    lon: 113.9388609,
    active: "1",
  },
  WKS: {
    tc_name: "烏溪沙",
    en_name: "Wu Kai Sha",
    lat: 22.4288765,
    lon: 114.2412396,
    active: "1",
  },
  MOS: {
    tc_name: "馬鞍山",
    en_name: "Ma On Shan",
    lat: 22.42482,
    lon: 114.2290739,
    active: "1",
  },
  HEO: {
    tc_name: "恆安",
    en_name: "Heng On",
    lat: 22.41732,
    lon: 114.2231251,
    active: "1",
  },
  TSH: {
    tc_name: "大水坑",
    en_name: "Tai Shui Hang",
    lat: 22.4077785,
    lon: 114.2201536,
    active: "1",
  },
  SHM: {
    tc_name: "石門",
    en_name: "Shek Mun",
    lat: 22.387694,
    lon: 114.2038429,
    active: "1",
  },
  CIO: {
    tc_name: "第一城",
    en_name: "City One",
    lat: 22.382832,
    lon: 114.2012041,
    active: "1",
  },
  STW: {
    tc_name: "沙田圍",
    en_name: "Sha Tin Wai",
    lat: 22.3769845,
    lon: 114.1922102,
    active: "1",
  },
  CKT: {
    tc_name: "車公廟",
    en_name: "Che Kung Temple",
    lat: 22.3746253,
    lon: 114.1834543,
    active: "1",
  },
  TAW: {
    tc_name: "大圍",
    en_name: "Tai Wai",
    lat: 22.3727375,
    lon: 114.1766281,
    interChange: ["EAL", "TML"],
    active: "1",
  },
  HIK: {
    tc_name: "顯徑",
    en_name: "Hin Keng",
    lat: 22.363834,
    lon: 114.1682151,
    active: "1",
  },
  DIH: {
    tc_name: "鑽石山",
    en_name: "Diamond Hill",
    lat: 22.340017,
    lon: 114.1971919,
    interChange: ["KTL", "TML"],
    active: "1",
  },
  KAT: {
    tc_name: "啟德",
    en_name: "Kai Tak",
    lat: 22.33057,
    lon: 114.1969741,
    active: "1",
  },
  SUW: {
    tc_name: "宋皇臺",
    en_name: "Sung Wong Toi",
    lat: 22.32591,
    lon: 114.1887251,
    active: "1",
  },
  TKW: {
    tc_name: "土瓜灣",
    en_name: "To Kwa Wan",
    lat: 22.3173048,
    lon: 114.1464003,
    active: "1",
  },
  HOM: {
    tc_name: "何文田",
    en_name: "Ho Man Tin",
    lat: 22.3091957,
    lon: 114.1796293,
    interChange: ["KTL", "TML"],
    active: "1",
  },
  HUH: {
    tc_name: "紅磡",
    en_name: "Hung Hom",
    lat: 22.3027389,
    lon: 114.1795387,
    interChange: ["EAL", "TML"],
    active: "1",
  },
  ETS: {
    tc_name: "尖東",
    en_name: "East Tsim Sha Tsui",
    lat: 22.296635,
    lon: 114.1718821,
    interChange: ["TML", "TWL"],
    connectedStations: ["TST"], // 連接尖沙咀站
    active: "1",
  },
  AUS: {
    tc_name: "柯士甸",
    en_name: "Austin",
    lat: 22.3049085,
    lon: 114.1644976,
    interChange: ["TCL", "TML"],
    connectedStations: ["KOW"], // 連接九龍站
    active: "1",
  },
  MEF: {
    tc_name: "美孚",
    en_name: "Mei Foo",
    lat: 22.3371202,
    lon: 114.1367434,
    interChange: ["TWL", "TML"],
    active: "1",
  },
  TWW: {
    tc_name: "荃灣西",
    en_name: "Tsuen Wan West",
    lat: 22.3703338,
    lon: 114.1083245,
    active: "1",
  },
  KSR: {
    tc_name: "錦上路",
    en_name: "Kam Sheung Road",
    lat: 22.4344826,
    lon: 114.0608712,
    active: "1",
  },
  YUL: {
    tc_name: "元朗",
    en_name: "Yuen Long",
    lat: 22.4462245,
    lon: 114.0318021,
    active: "1",
  },
  LOP: {
    tc_name: "朗屏",
    en_name: "Long Ping",
    lat: 22.4476344,
    lon: 114.0229864,
    active: "1",
  },
  TIS: {
    tc_name: "天水圍",
    en_name: "Tin Shui Wai",
    lat: 22.3755646,
    lon: 114.0173264,
    active: "1",
  },
  SIH: {
    tc_name: "兆康",
    en_name: "Siu Hong",
    lat: 22.4108562,
    lon: 113.9761296,
    active: "1",
  },
  TUM: {
    tc_name: "屯門",
    en_name: "Tuen Mun",
    lat: 22.3497468,
    lon: 113.9954102,
    active: "1",
  },
  NOP: {
    tc_name: "北角",
    en_name: "North Point",
    lat: 22.2915886,
    lon: 114.1977624,
    interChange: ["ISL", "TKL"],
    active: "1",
  },
  QUB: {
    tc_name: "鰂魚涌",
    en_name: "Quarry Bay",
    lat: 22.2878748,
    lon: 114.2071718,
    interChange: ["ISL", "TKL"],
    active: "1",
  },
  YAT: {
    tc_name: "油塘",
    en_name: "Yau Tong",
    lat: 22.3054648,
    lon: 114.1626253,
    interChange: ["KTL", "TKL"],
    active: "1",
  },
  TIK: {
    tc_name: "調景嶺",
    en_name: "Tiu Keng Leng",
    lat: 22.3044835,
    lon: 114.250292,
    interChange: ["KTL", "TKL"],
    active: "1",
  },
  TKO: {
    tc_name: "將軍澳",
    en_name: "Tseung Kwan O",
    lat: 22.3072079,
    lon: 114.2575438,
    active: "1",
  },
  LHP: {
    tc_name: "康城",
    en_name: "LOHAS Park",
    lat: 22.2963175,
    lon: 114.2670383,
    active: "1",
  },
  HAH: {
    tc_name: "坑口",
    en_name: "Hang Hau",
    lat: 22.299094,
    lon: 114.1868597,
    active: "1",
  },
  POA: {
    tc_name: "寶琳",
    en_name: "Po Lam",
    lat: 22.3224945,
    lon: 114.2549441,
    active: "1",
  },
  LMC: {
    tc_name: "落馬洲",
    en_name: "Lok Ma Chau",
    lat: 22.5148304,
    lon: 114.0630702,
    active: "1",
  },
  LOW: {
    tc_name: "羅湖",
    en_name: "Lo Wu",
    lat: 22.4138281,
    lon: 114.0927552,
    tc_rmk: "",
    en_rmk: "",
    active: "1",
  },
  SHS: {
    tc_name: "上水",
    en_name: "Sheung Shui",
    lat: 22.501007,
    lon: 114.1256609,
    active: "1",
  },
  FAN: {
    tc_name: "粉嶺",
    en_name: "Fanling",
    lat: 22.491949,
    lon: 114.1362691,
    active: "1",
  },
  TWO: {
    tc_name: "太和",
    en_name: "Tai Wo",
    lat: 22.410799,
    lon: 114.1062783,
    active: "1",
  },
  TAP: {
    tc_name: "大埔墟",
    en_name: "Tai Po Market",
    lat: 22.2924968,
    lon: 114.2033841,
    active: "1",
  },
  UNI: {
    tc_name: "大學",
    en_name: "University",
    lat: 22.3487907,
    lon: 114.089888,
    active: "1",
  },
  RAC: {
    tc_name: "馬場",
    en_name: "Racecourse",
    lat: 22.4010082,
    lon: 114.2007362,
    active: "1",
  },
  FOT: {
    tc_name: "火炭",
    en_name: "Fo Tan",
    lat: 22.395491,
    lon: 114.1959519,
    active: "1",
  },
  SHT: {
    tc_name: "沙田",
    en_name: "Sha Tin",
    lat: 22.3804806,
    lon: 114.1858325,
    active: "1",
  },
  KOT: {
    tc_name: "九龍塘",
    en_name: "Kowloon Tong",
    lat: 22.3371583,
    lon: 114.173518,
    interChange: ["KTL", "EAL"],
    active: "1",
  },
  MKK: {
    tc_name: "旺角東",
    en_name: "Mong Kok East",
    lat: 22.32206,
    lon: 114.1698501,
    active: "1",
  },
  EXC: {
    tc_name: "會展",
    en_name: "Exhibition Centre",
    lat: 22.2821415,
    lon: 114.1729261,
    active: "1",
  },
  ADM: {
    tc_name: "金鐘",
    en_name: "Admiralty",
    lat: 22.279412,
    lon: 114.1619841,
    interChange: ["ISL", "TWL", "SIL", "EAL"],
    active: "1",
  },
  OCP: {
    tc_name: "海洋公園",
    en_name: "Ocean Park",
    lat: 22.2486966,
    lon: 114.171868,
    active: "1",
  },
  WCH: {
    tc_name: "黃竹坑",
    en_name: "Wong Chuk Hang",
    lat: 22.247444,
    lon: 114.1655451,
    active: "1",
  },
  LET: {
    tc_name: "利東",
    en_name: "Lei Tung",
    lat: 22.2420816,
    lon: 114.1533846,
    active: "1",
  },
  SOH: {
    tc_name: "海怡半島",
    en_name: "South Horizons",
    lat: 22.2428603,
    lon: 114.1461695,
    active: "1",
  },
  TSW: {
    tc_name: "荃灣",
    en_name: "Tsuen Wan",
    lat: 22.3711934,
    lon: 114.1089161,
    active: "1",
  },
  TWH: {
    tc_name: "大窩口",
    en_name: "Tai Wo Hau",
    lat: 22.3707505,
    lon: 114.1227346,
    active: "1",
  },
  KWH: {
    tc_name: "葵興",
    en_name: "Kwai Hing",
    lat: 22.363471,
    lon: 114.1286801,
    active: "1",
  },
  KWF: {
    tc_name: "葵芳",
    en_name: "Kwai Fong",
    lat: 22.3568312,
    lon: 114.1252402,
    active: "1",
  },
  LCK: {
    tc_name: "茘枝角",
    en_name: "Lai Chi Kok",
    lat: 22.3374765,
    lon: 114.1458141,
    active: "1",
  },
  CSW: {
    tc_name: "長沙灣",
    en_name: "Cheung Sha Wan",
    lat: 22.3356101,
    lon: 114.1534211,
    active: "1",
  },
  SSP: {
    tc_name: "深水埗",
    en_name: "Sham Shui Po",
    lat: 22.3307737,
    lon: 114.1596919,
    active: "1",
  },
  PRE: {
    tc_name: "太子",
    en_name: "Prince Edward",
    lat: 22.32489,
    lon: 114.1661386,
    interChange: ["KTL", "TWL"],
    active: "1",
  },
  MOK: {
    tc_name: "旺角",
    en_name: "Mong Kok",
    lat: 22.3206515,
    lon: 114.16969,
    interChange: ["KTL", "TWL"],
    active: "1",
  },
  YMT: {
    tc_name: "油麻地",
    en_name: "Yau Ma Tei",
    lat: 22.31245,
    lon: 114.1677633,
    interChange: ["KTL", "TWL"],
    active: "1",
  },
  JOR: {
    tc_name: "佐敦",
    en_name: "Jordan",
    lat: 22.2924968,
    lon: 114.2033841,
    active: "1",
  },
  TST: {
    tc_name: "尖沙咀",
    en_name: "Tsim Sha Tsui",
    lat: 22.296635,
    lon: 114.1718821,
    interChange: ["TWL", "TML"],
    connectedStations: ["ETS"], // 連接尖東站
    active: "1",
  },
  CEN: {
    tc_name: "中環",
    en_name: "Central",
    lat: 22.3015533,
    lon: 114.1518727,
    interChange: ["ISL", "TWL"],
    connectedStations: ["HOK"], // 連接香港站
    active: "1",
  },
  KET: {
    tc_name: "堅尼地城",
    en_name: "Kennedy Town",
    lat: 22.2813235,
    lon: 114.1258118,
    active: "1",
  },
  HKU: {
    tc_name: "香港大學",
    en_name: "HKU",
    lat: 22.284204,
    lon: 114.1320936,
    active: "1",
  },
  SYP: {
    tc_name: "西營盤",
    en_name: "Sai Ying Pun",
    lat: 22.2860045,
    lon: 114.1396651,
    active: "1",
  },
  SHW: {
    tc_name: "上環",
    en_name: "Sheung Wan",
    lat: 22.2865601,
    lon: 114.1492965,
    active: "1",
  },
  WAC: {
    tc_name: "灣仔",
    en_name: "Wan Chai",
    lat: 22.2711063,
    lon: 114.1639461,
    active: "1",
  },
  CAB: {
    tc_name: "銅鑼灣",
    en_name: "Causeway Bay",
    lat: 22.2803747,
    lon: 114.1824672,
    active: "1",
  },
  TIH: {
    tc_name: "天后",
    en_name: "Tin Hau",
    lat: 22.2824215,
    lon: 114.1891509,
    active: "1",
  },
  FOH: {
    tc_name: "炮台山",
    en_name: "Fortress Hill",
    lat: 22.2881344,
    lon: 114.1911083,
    active: "1",
  },
  TAK: {
    tc_name: "太古",
    en_name: "Tai Koo",
    lat: 22.284875,
    lon: 114.2128626,
    active: "1",
  },
  SWH: {
    tc_name: "西灣河",
    en_name: "Sai Wan Ho",
    lat: 22.2820601,
    lon: 114.2197325,
    active: "1",
  },
  SKW: {
    tc_name: "筲箕灣",
    en_name: "Shau Kei Wan",
    lat: 22.2789779,
    lon: 114.2266953,
    active: "1",
  },
  HFC: {
    tc_name: "杏花邨",
    en_name: "Heng Fa Chuen",
    lat: 22.27681,
    lon: 114.2373368,
    active: "1",
  },
  CHW: {
    tc_name: "柴灣",
    en_name: "Chai Wan",
    lat: 22.2640684,
    lon: 114.2342923,
    active: "1",
  },
  WHA: {
    tc_name: "黃埔",
    en_name: "Whampoa",
    lat: 22.30503,
    lon: 114.1850439,
    active: "1",
  },
  SKM: {
    tc_name: "石硤尾",
    en_name: "Shek Kip Mei",
    lat: 22.3318964,
    lon: 114.1660876,
    active: "1",
  },
  LOF: {
    tc_name: "樂富",
    en_name: "Lok Fu",
    lat: 22.338026,
    lon: 114.1825159,
    active: "1",
  },
  WTS: {
    tc_name: "黃大仙",
    en_name: "Wong Tai Sin",
    lat: 22.341433,
    lon: 114.1921916,
    active: "1",
  },
  CHH: {
    tc_name: "彩虹",
    en_name: "Choi Hung",
    lat: 22.3345484,
    lon: 114.2069476,
    active: "1",
  },
  KOB: {
    tc_name: "九龍灣",
    en_name: "Kowloon Bay",
    lat: 22.3125219,
    lon: 114.1746388,
    active: "1",
  },
  NTK: {
    tc_name: "牛頭角",
    en_name: "Ngau Tau Kok",
    lat: 22.3153475,
    lon: 114.2168817,
    active: "1",
  },
  KWT: {
    tc_name: "觀塘",
    en_name: "Kwun Tong",
    lat: 22.3244063,
    lon: 114.1809323,
    active: "1",
  },
  LAT: {
    tc_name: "藍田",
    en_name: "Lam Tin",
    lat: 22.306708,
    lon: 114.2306426,
    active: "1",
  },
  DIS: {
    tc_name: "迪士尼",
    en_name: "Disneyland Resort",
    lat: 22.3153543,
    lon: 114.0426127,
    active: "1",
  },
};

const MTR_Dict = { Common, MtrLines, MtrStations, Error };

export default MTR_Dict;
